<template>
  <Form ref="formUser" @submit.prevent="save">
    <div class="row mt-2">
      <div class="col-md-6">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-6">
              <ZInput class="mb-2" v-model="firstName" :value="firstName" name="firstName" label="First Name"
                validate="required" tabindex="1" />
              <ZInput class="mb-2" v-model="username" :value="username" name="username" autocomplete="new-password"
                label="Username (email address)" validate="required" tabindex="3" v-if="isAdding" @blur="verifyUser" />
              <div class="mb-4 custom-username" v-else>
                <label class="me-2">Username:</label>
                <input v-if="editingUsername" v-model="newUsername" />
                <span v-else>{{ username }}</span>
                <a href="#" @click="editUsername" v-show="!editingUsername">
                  <i class="fas fa-pencil-alt"></i>
                </a>
                <a href="#" @click="saveUsername" v-show="editingUsername">
                  <i class="fas fa-save"></i>
                </a>
              </div>
            </div>
            <div class="col-md-6">
              <ZInput class="mb-2" v-model="lastName" :value="lastName" name="lastName" label="Last Name"
                validate="required" tabindex="2" />
              <ZSelect class="mb-2" v-model="contactType" :value="contactType" name="contactType" label="Contact Type"
                :options="lookups['UserContactType']" validate="required" tabindex="4" v-show="cameFrom > 0" />
            </div>
          </div>
        </div>
        <div class="col-md-12" v-if="cameFrom === 1">
          <div class="row mt-2">
            <div class="form-group col-md-6">
              <ZSelect v-model="timezone" :value="timezone" label="Time Zone" name="timezone"
                :options="lookups['TimeZone']" validate="required" tabindex="5" />
            </div>
            <div class="form-group col-md-6">
              <ZSelect v-model="language" :value="language" label="Language" name="language"
                :options="lookups['Language']" validate="required" tabindex="6" />
            </div>
          </div>
          <div class="row my-2" v-if="isAdding">
            <div class="form-group col-md-6">
              <ZInput type="password" v-model="password" :value="password" autocomplete="new-password" name="password"
                label="Password" validate="required" @blur="verifyPassword" tabindex="7" />
            </div>
            <div class="form-group col-md-6">
              <ZInput type="password" v-model="newpassword" :value="newpassword" autocomplete="new-password"
                name="newpassword" label="Password (again)" validate="required" @blur="verifyPassword" tabindex="8" />
            </div>
          </div>
          <div class="row my-2">
            <div class="form-group col-md-6">
              <ZSelect v-model="role" :value="role" name="role" label="User Role" :options="roles" validate="required"
                tabindex="9" />
            </div>
            <div class="form-group col-md-6">
              <ZInput v-model="laborRate" :value="laborRate" name="laborRate" label="Labor Rate (per hr)" type="number"
                validate="required" tabindex="10" />
            </div>
          </div>
          <div class="row my-2" v-if="isPartner">
            <div class="form-group col-md-6">
              <ZInput v-model="partnerName" :value="partnerName" name="partnerName" label="Partner Company Name" />
            </div>
            <div class="form-group col-md-6"></div>
          </div>
          <div class="row my-2">
            <div class="form-group col-md-12 pl-4">
              <input type="checkbox" v-model="isInactive" class="custom-checkbox" tabindex="11" />
              <span class="ml-1 mr-4">Inactive?</span>
              <input type="checkbox" v-model="receivesReport" class="custom-checkbox" tabindex="12" />
              <span class="ml-1 mr-4">Receives Reports</span>
              <input type="checkbox" v-model="receivesInvoice" class="custom-checkbox" tabindex="13" />
              <span class="ml-1">Receives Invoices</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12">
              <span>{{ firmName }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-12" v-else>
          <FileUpload ref="fileUploader" v-show="isReadyToUpload" :endpoint="endpoint" :path="path" :folder="folder"
            :userId="userId" :firmId="firmId" @finished="finishedUploading" :title="title" :subtitle="subTitle"
            :instructions="instructions" />
          <img v-show="!isReadyToUpload" :src="profilePhoto" class="img-responsive img-thumbnail custom-image"
            :alt="defaultPhoto" />
          <a href="#" @click="setReadyToUpload(true)" v-show="!isReadyToUpload">upload new photo</a>
        </div>
      </div>
      <div class="col-md-6" v-if="!isAdding || (isAdding && isSaved)">
        <UserRecord :recordData="user" :showTitles="showTitles" :stacked="stacked" />
      </div>
      <div class="col-md-6" v-else-if="isVerified">
        <button class="btn btn-primary" @click="save" tabindex="12" style="margin-top: 31px;">Add New User</button>
      </div>
    </div>
  </Form>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { lookups, users } from '@/stores'
import ZInput from '@/components/utilities/elements/Input.vue'
import ZSelect from '@/components/utilities/elements/Select.vue'
import UserRecord from '@/components/users/listings/user-record.vue'
import FileUpload from '@/components/utilities/elements/Upload.vue'
import { Form } from 'vee-validate'
export default {
  name: 'user-profile',
  components: {
    ZInput,
    ZSelect,
    UserRecord,
    FileUpload,
    Form
  },
  props: {
    cameFrom: {
      type: Number,
      default: 0
    },
    isAdd: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isSaved: false,
      showTitles: true,
      stacked: true,
      endpoint: '/firm/saveToBucket',
      path: '/images/',
      defaultPhoto: null,
      readyToUpload: false,
      newpassword: '',
      isAdding: false,
      isVerified: false,
      newUsername: '',
      editingUsername: false
    }
  },
  mounted() {
    this.isAdding = this.isAdd
    this.isVerified = !this.isAdd
    this.newUsername = ''
    this.editingUsername = false
  },
  computed: {
    ...mapState(lookups, ['lookups']),
    ...mapState(users, ['user', 'roles']),
    firstName: {
      get() {
        return this.user !== null ? this.user.firstName : ''
      },
      set(value) {
        this.updateUser({
          name: 'firstName',
          value: value
        })
      }
    },
    lastName: {
      get() {
        return this.user !== null ? this.user.lastName : ''
      },
      set(value) {
        this.updateUser({
          name: 'lastName',
          value: value
        })
      }
    },
    timezone: {
      get() {
        return this.user !== null ? this.user.timezone : ''
      },
      set(value) {
        this.updateUser({
          name: 'timezone',
          value: value
        })
      }
    },
    language: {
      get() {
        return this.user !== null ? this.user.language : ''
      },
      set(value) {
        this.updateUser({
          name: 'language',
          value: value
        })
      }
    },
    username: {
      get() {
        return this.user !== null ? this.user.username : ''
      },
      set(value) {
        this.updateUser({
          name: 'username',
          value: value
        })
      }
    },
    password: {
      get() {
        return this.user !== null ? this.user.password : ''
      },
      set(value) {
        this.updateUser({
          name: 'password',
          value: value
        })
      }
    },
    contactType: {
      get() {
        return this.user !== null ? this.user.contactType : 0
      },
      set(value) {
        this.updateUser({
          name: 'contactType',
          value: value
        })
      }
    },
    role: {
      get() {
        let _role = 0
        if (this.user !== null) {
          if (this.user.roles !== null) {
            if (this.user.roles.indexOf(',') > 0) {
              var roles = this.user.roles.split(',')
              _role = roles[0]
            } else {
              _role = this.user.roles
            }
          }
        }
        return _role
      },
      set(value) {
        this.updateUser({
          name: 'role',
          value: value
        })
      }
    },
    laborRate: {
      get() {
        return this.user !== null ? this.user.laborRate : ''
      },
      set(value) {
        this.updateUser({
          name: 'laborRate',
          value: value
        })
      }
    },
    isInactive: {
      get() {
        return this.user !== null ? this.user.isInactive : false
      },
      set(value) {
        this.updateUser({
          name: 'isInactive',
          value: value
        })
      }
    },
    receivesReport: {
      get() {
        return this.user !== null ? this.user.receivesReport : false
      },
      set(value) {
        this.updateUser({
          name: 'receivesReport',
          value: value
        })
      }
    },
    receivesInvoice: {
      get() {
        return this.user !== null ? this.user.receivesInvoice : false
      },
      set(value) {
        this.updateUser({
          name: 'receivesInvoice',
          value: value
        })
      }
    },
    email: {
      get() {
        return this.user !== null ? this.user.username : ''
      }
    },
    folder: {
      get() {
        return this.user !== null ? this.user.firm + '/' : ''
      }
    },
    userId: {
      get() {
        return this.user !== null ? this.user.userId : ''
      }
    },
    firmId: {
      get() {
        return this.user !== null ? this.user.firm : ''
      }
    },
    isReadyToUpload: {
      get() {
        let _showIt = true
        if (this.user !== null) {
          if (this.user.imagePhotoPath !== '') {
            _showIt = false
          }
        }
        if (_showIt === false) {
          if (this.readyToUpload) {
            _showIt = true
          }
        }
        return _showIt
      }
    },
    profilePhoto: {
      get() {
        return this.user !== null ? this.user.profileImagePath : ''
      }
    },
    firmName() {
      let _name = null
      if (this.user !== undefined && this.user !== null) {
        if (this.user.location !== undefined && this.user.location !== null) {
          _name = this.user.location.name
        }
      }
      return _name
    },
    isPartner() {
      let _is = false
      if (this.role !== '') {
        if (parseInt(this.role) === 3) {
          _is = true
        }
      }
      return _is
    },
    partnerName: {
      get() {
        return this.user !== null ? this.user.partnerName : ''
      },
      set(value) {
        this.updateUser({
          name: 'partnerName',
          value: value
        })
      }
    },
    title: {
      get() {
        return 'Upload Profile Image'
      }
    },
    subTitle: {
      get() {
        return '(in png, jpg format)'
      }
    },
    instructions: {
      get() {
        return 'Drag your profile image (in png or jpg format) here to begin<br> or click to browse'
      }
    }
  },
  methods: {
    ...mapActions(users, ['getUser', 'saveUser', 'updateUser', 'verifyUsername']),
    setReadyToUpload(value) {
      this.readyToUpload = value
    },
    close() {
      this.$emit('closing')
    },
    async finishedUploading(response) {
      await this.getUser(this.user.username)
      this.updateUser({ name: 'profileImagePath', value: response })
      this.$refs.fileUploader.reset()
      this.readyToUpload = false
    },
    editUsername() {
      this.newUsername = this.username
      this.editingUsername = true
    },
    saveUsername() {
      this.username = this.newUsername
      this.editingUsername = false
      this.save()
    },
    validatePassword() {
      let valid = true
      this.reason = ''
      if (this.isLoading === false && this.password !== '') {
        let strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})')
        valid = strongRegex.test(this.password)
        if (valid === false) {
          this.reason = "Password doesn't meet minimum strength of special characters (!@#$%^&*), lower case (a-z), upper case (A-Z) and numbers (0-9), and at least 8 characters in length."
        }
      }
      return valid
    },
    verifyPassword() {
      if (!this.validatePassword()) {
        alert(this.reason)
      }
    },
    async verifyUser() {
      this.isVerified = false
      let data = await this.verifyUsername(this.user.username)
      if (data.isThere) {
        alert('Username already exists, please try another.')
      } else {
        this.isVerified = true
      }
    },
    async save() {
      let notice = 'Please supply fill all fields.'
      this.$refs.formUser.validate().then(async success => {
        let valid = true
        if (success.valid) {
          if (this.user.timezone) {
            this.updateUser({
              name: 'timezone',
              value: parseInt(this.user.timezone)
            })
          }
          if (this.user.timezone === 0) {
            valid = false
            notice += '  Please supply a Timezone.'
          }
          if (this.user.language === 0) {
            valid = false
            notice += '  Please supply a Language.'
          }
          console.log('Saving the User Profile', this.user)
          if (valid) {
            await this.saveUser(this.user)
            this.isSaved = true
            if (this.isAdding) {
              console.log('Refreshing User after Adding')
              await this.getUser(this.user.username)
            }
            this.$emit('saved', this.isSaved)
            this.isAdding = false
          } else {
            alert(notice)
          }
        } else {
          alert(notice)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-image {
  width: 300px;
  height: 300px;
  margin-right: 10px;
}

.custom-username {
  position: relative;

  a {
    float: right;
    color: #2c6ffe;
  }
}
</style>
